// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.form-list {
  margin-left: 30px;
}

.relative {
  position: relative;
}

::ng-deep .mat-dialog-content {
  max-height: 80vh;
}

.form-container {
  overflow: scroll;
  padding: 20px;
  height: 530px;
}

.mat-dialog-actions[align=end] {
  justify-content: flex-end;
}

h1 {
  margin-bottom: -5px;
}

.cdk-overlay-pane.my-dialog {
  position: relative !important;
}

.close.mat-button {
  position: absolute;
  top: 15px;
  right: 0;
  line-height: 14px;
  min-width: auto;
}

/* For device */
@media (min-width: 0px) and (max-width: 400px) {
  .mat-dialog-content {
    padding: 0 15px;
    max-height: 85vh;
  }
  .form-container {
    padding: 10px;
  }
}
@media (min-width: 400px) and (max-width: 766px) {
  .mat-dialog-content {
    padding: 0 15px;
  }
}
@media (min-height: 0px) and (max-height: 330px) {
  .form-container {
    height: 200px;
  }
}
@media (min-height: 330px) and (max-height: 400px) {
  .form-container {
    height: 250px;
  }
}
@media (min-height: 400px) and (max-height: 500px) {
  .form-container {
    height: 300px;
  }
}
@media (min-height: 500px) and (max-height: 667px) {
  .form-container {
    height: 450px;
  }
}
@media (min-height: 667px) and (max-height: 1400px) {
  .form-container {
    height: 530px;
  }
}
.mat-dialog-content {
  max-height: unset !important;
}

.d-none {
  display: none;
}`, "",{"version":3,"sources":["webpack://./src/app/e-form/form-generate/form-generate.component.scss"],"names":[],"mappings":"AAAA;EACG,iBAAA;AACH;;AAEA;EACG,kBAAA;AACH;;AAEA;EACG,gBAAA;AACH;;AAEA;EACG,gBAAA;EACA,aAAA;EACA,aAAA;AACH;;AAGG;EACG,yBAAA;AAAN;;AAIA;EACG,mBAAA;AADH;;AAIA;EACG,6BAAA;AADH;;AAIA;EACG,kBAAA;EACA,SAAA;EACA,QAAA;EACA,iBAAA;EACA,eAAA;AADH;;AAIA,eAAA;AACA;EACG;IACG,eAAA;IACA,gBAAA;EADJ;EAGC;IACG,aAAA;EADJ;AACF;AAIA;EACG;IACG,eAAA;EAFJ;AACF;AAKA;EACG;IACG,aAAA;EAHJ;AACF;AAMA;EACG;IACG,aAAA;EAJJ;AACF;AAOA;EACG;IACG,aAAA;EALJ;AACF;AAQA;EACG;IACG,aAAA;EANJ;AACF;AASA;EACG;IACG,aAAA;EAPJ;AACF;AAUA;EACG,4BAAA;AARH;;AAWA;EACG,aAAA;AARH","sourcesContent":[".form-list {\n   margin-left: 30px;\n}\n\n.relative {\n   position: relative;\n}\n\n::ng-deep .mat-dialog-content {\n   max-height: 80vh;\n}\n\n.form-container {\n   overflow: scroll;\n   padding: 20px;\n   height: 530px;\n}\n\n.mat-dialog-actions {\n   &[align='end'] {\n      justify-content: flex-end;\n   }\n}\n\nh1 {\n   margin-bottom: -5px;\n}\n\n.cdk-overlay-pane.my-dialog {\n   position: relative !important;\n}\n\n.close.mat-button {\n   position: absolute;\n   top: 15px;\n   right: 0;\n   line-height: 14px;\n   min-width: auto;\n}\n\n/* For device */\n@media (min-width: 0px) and (max-width: 400px) {\n   .mat-dialog-content {\n      padding: 0 15px;\n      max-height: 85vh;\n   }\n   .form-container {\n      padding: 10px;\n   }\n}\n\n@media (min-width: 400px) and (max-width: 766px) {\n   .mat-dialog-content {\n      padding: 0 15px;\n   }\n}\n\n@media (min-height: 0px) and (max-height: 330px) {\n   .form-container {\n      height: 200px;\n   }\n}\n\n@media (min-height: 330px) and (max-height: 400px) {\n   .form-container {\n      height: 250px;\n   }\n}\n\n@media (min-height: 400px) and (max-height: 500px) {\n   .form-container {\n      height: 300px;\n   }\n}\n\n@media (min-height: 500px) and (max-height: 667px) {\n   .form-container {\n      height: 450px;\n   }\n}\n\n@media (min-height: 667px) and (max-height: 1400px) {\n   .form-container {\n      height: 530px;\n   }\n}\n\n.mat-dialog-content {\n   max-height: unset !important;\n}\n\n.d-none {\n   display: none;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
